import DOM from '@common/DOM/DOM'

import { ECanvasEvent } from './definitions'

/**
 * Canvason történő animáció folytatása.
 * @param canvas - Canvas.
 */
export default function resumeCanvas (canvas: HTMLCanvasElement): void {
  DOM.dispatch(canvas, ECanvasEvent.Resume)

  // DEPRECATED COMMENT - WTF - beszélni róla
  // NE visible legyen, mert ha az ős visibility-je hidden, és ez visible, akkor látszódni fog.
  // Ezt a problémát megoldja az 'auto'.
  canvas.style.removeProperty('visibility')
}
